
export const TEMPLATE_ADD_PAGE = '/custom'
export const TEMPLATE_VERSION = {
  V1 : 'v1',
  V2 : 'v2'
}